import Component from './EnabledTimeLastActive.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconEnabledTimeLastActive', Component);
  },
};
